import API from "api/API";
import useFetchData from "hooks/useFetchData";
import useAZZKULatestEditionID from "./useAZZKULatestEditionID";

export default function useAZZKUProfessionsSearch( s ) {
   const edition_id = useAZZKULatestEditionID();
   return useFetchData({
      APIMethod: API.searchAZZKUProfessions,
      condition: !!edition_id && !!s,
      params: [ edition_id, s ],
      resultDataHandler: data => data.map( p => ({
         value: p.id,
         label: p.name
      }))
   });
}